import React, { useContext, useState } from "react";
import Column from "@amzn/meridian/column";
import { useDeviceLayout } from "../../common/context/DeviceLayoutContext";
import { PermissionsContext } from "../../permissions/PermissionsContext";
import Alert from "@amzn/meridian/alert";

const SettingsAuthorizationCustomAlert = ({ width, title = "" }) => {
  const { isUserAuthorisedForSettingsEdit } = useContext(PermissionsContext);
  const [isWarningsBanner, setWarningsBanner] = useState(true);
  const { spacingInset_shorthand2 } = useDeviceLayout();
  return !isUserAuthorisedForSettingsEdit && isWarningsBanner ? (
    <Column
      spacingInset={spacingInset_shorthand2}
      width={width ? width : "25%"}
      className="alert-border"
      spacing={"none"}
    >
      <Alert
        type={"warning"}
        size={"large"}
        onClose={() => {
          setWarningsBanner(false);
        }}
      >
        {title}
      </Alert>
    </Column>
  ) : (
    ""
  );
};

export default SettingsAuthorizationCustomAlert;



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/SettingsAuthorizationCustomAlert.js